import { render, staticRenderFns } from "./NavbarHeader.vue?vue&type=template&id=f45ae15c&scoped=true"
import script from "./NavbarHeader.vue?vue&type=script&lang=js"
export * from "./NavbarHeader.vue?vue&type=script&lang=js"
import style0 from "./NavbarHeader.vue?vue&type=style&index=0&id=f45ae15c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45ae15c",
  null
  
)

export default component.exports